import {
  errorMetaData,
  pendingMetaData,
  successMetaData,
} from "@workspace/common";
import {
  // Create
  CREATE_BENEFIT,
  CREATE_BENEFIT_SUCCESS,
  CREATE_BENEFIT_FAILURE,
  FETCH_BENEFITS,
  FETCH_BENEFITS_SUCCESS,
  FETCH_BENEFITS_FAILURE,
  UPDATE_BENEFIT,
  UPDATE_BENEFIT_SUCCESS,
  UPDATE_BENEFIT_FAILURE,
  DELETE_BENEFIT,
  DELETE_BENEFIT_SUCCESS,
  DELETE_BENEFIT_FAILURE,
  GET_BENEFIT,
  GET_BENEFIT_SUCCESS,
  GET_BENEFIT_FAILURE,
  RESET_BENEFIT,
  DELETE_BENEFITS,
  DELETE_BENEFITS_SUCCESS,
  DELETE_BENEFITS_FAILURE,
  GET_BENEFIT_VALUES,
  GET_BENEFIT_VALUES_SUCCESS,
  GET_BENEFIT_VALUES_FAILURE,
} from "./actionTypes";

const initialState = {
  benefits: null,
  benefitsMeta: null,
  benefitCreate: null,
  benefitCreateMeta: null,
  benefitUpdate: null,
  benefitUpdateMeta: null,
  benefitDelete: null,
  benefitDeleteMeta: null,
  benefit: null,
  benefitMeta: null,
  benefitValues: null,
  benefitValuesMeta: null,
};

const BenefitsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Benefits
    case FETCH_BENEFITS:
      return {
        ...state,
        benefitsMeta: pendingMetaData(),
      };
    case FETCH_BENEFITS_SUCCESS:
      return {
        ...state,
        benefitsMeta: successMetaData(action.payload),
        benefits: action.payload,
      };
    case FETCH_BENEFITS_FAILURE:
      return {
        ...state,
        benefitsMeta: errorMetaData(action.payload),
      };
    // Create Benefit
    case CREATE_BENEFIT:
      return {
        ...state,
        benefitCreateMeta: pendingMetaData(),
      };
    case CREATE_BENEFIT_SUCCESS:
      return {
        ...state,
        benefitCreateMeta: successMetaData(action.payload),
        benefitCreate: action.payload,
      };
    case CREATE_BENEFIT_FAILURE:
      return {
        ...state,
        benefitCreateMeta: errorMetaData(action.payload),
      };
    // Update Benefit
    case UPDATE_BENEFIT:
      return {
        ...state,
        benefitUpdateMeta: pendingMetaData(),
      };
    case UPDATE_BENEFIT_SUCCESS:
      return {
        ...state,
        benefitUpdateMeta: successMetaData(action.payload),
        benefitUpdate: action.payload,
      };
    case UPDATE_BENEFIT_FAILURE:
      return {
        ...state,
        benefitUpdateMeta: errorMetaData(action.payload),
      };
    // Delete Benefit
    case DELETE_BENEFIT:
      return {
        ...state,
        benefitDeleteMeta: pendingMetaData(),
      };
    case DELETE_BENEFIT_SUCCESS:
      return {
        ...state,
        benefitDeleteMeta: successMetaData(action.payload),
      };
    case DELETE_BENEFIT_FAILURE:
      return {
        ...state,
        benefitDeleteMeta: errorMetaData(action.payload),
      };
    // Delete Benefits
    case DELETE_BENEFITS:
      return {
        ...state,
        benefitDeleteMeta: pendingMetaData(),
      };
    case DELETE_BENEFITS_SUCCESS:
      return {
        ...state,
        benefitDeleteMeta: successMetaData(action.payload),
      };
    case DELETE_BENEFITS_FAILURE:
      return {
        ...state,
        benefitDeleteMeta: errorMetaData(action.payload),
      };
    case GET_BENEFIT:
      return {
        ...state,
        benefitMeta: pendingMetaData(),
      };
    case GET_BENEFIT_SUCCESS:
      return {
        ...state,
        benefitMeta: successMetaData(action.payload),
        benefit: action.payload,
      };
    case GET_BENEFIT_FAILURE:
      return {
        ...state,
        benefitMeta: errorMetaData(action.payload),
      };
    case GET_BENEFIT_VALUES:
      return {
        ...state,
        benefitValuesMeta: pendingMetaData(),
      };
    case GET_BENEFIT_VALUES_SUCCESS:
      return {
        ...state,
        benefitValuesMeta: successMetaData(action.payload),
        benefitValues: action.payload,
      };
    case GET_BENEFIT_VALUES_FAILURE:
      return {
        ...state,
        benefitValuesMeta: errorMetaData(action.payload),
      };
    case RESET_BENEFIT:
      return {
        ...state,
        benefitCreate: null,
        benefitCreateMeta: null,
        benefitUpdate: null,
        benefitUpdateMeta: null,
        benefitDelete: null,
        benefitDeleteMeta: null,
        benefit: null,
        benefitMeta: null,
        benefitValues: null,
        benefitValuesMeta: null,
      };
    default:
      return state;
  }
};

export default BenefitsReducer;
